import React from "react";
import { Col, FormGroup, FormLabel, Row, Tab, Tabs } from "react-bootstrap";
import { labels } from "../../../../../localization/labels";
import { constants } from "../../../../../utils/Constants";
import ButtonBar from "../../../../core/ButtonBar";
import ComponentHeader from "../../../../core/ComponentHeader/ComponentHeader";
import ProcessComponent from "../../../../core/ProcessComponent";
import SubmitControl from "../../../../core/SubmitControl";
import Operations from "./Operations";

const InvolvementRoleType = props => {
  return (
    <ProcessComponent processes={[constants.OPERATION_SECURITY_ADMINISTRATION]}>
      <div className="container">
        <div className="containerShadow">
          <ComponentHeader
            title={labels.involvementRoleType}
            id={props.involvementRoleType.id}
            showBackButton
          />
          <div className="bordered_bottom_rounded">
            <Row>
              <Col sm="2">
                <FormLabel className="Label">{labels.name}</FormLabel>
              </Col>
              <Col sm="10">
                <FormGroup controlId="name">
                  <SubmitControl
                    autoFocus
                    type="text"
                    title={labels.name}
                    value={props.involvementRoleType.name}
                    onChange={props.onChange}
                    placeholder={labels.name}
                    validationRule={props.validationRules.name}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel className="Label">{labels.dateFromTo}</FormLabel>
              </Col>
              <Col sm="5">
                <FormGroup controlId="dateFromTo">
                  <SubmitControl
                    type="dateRange"
                    placeholder={[
                      labels.dateFromPlaceholder,
                      labels.dateToPlaceholder
                    ]}
                    value={props.involvementRoleType.dateFromTo}
                    onChange={props.onChange}
                    controlId={"dateFromTo"}
                    validationRule={props.validationRules?.dateFromTo}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col sm="2">
                <FormLabel className="Label">{labels.description}</FormLabel>
              </Col>
              <Col sm="10">
                <FormGroup controlId="description">
                  <SubmitControl
                    placeholder={labels.description}
                    as="textarea"
                    value={props.involvementRoleType.description}
                    onChange={props.onChange}
                    rows="2"
                  />
                </FormGroup>
              </Col>
            </Row>
            <Tabs id="operation_tabs" className="Tabs">
              <Tab
                eventKey="operation"
                title={labels.operations}
                className="Tab"
              >
                <Operations
                  entityOperations={props.involvementRoleType.operations}
                  messageHandler={props.messageHandler}
                  breadcrumbsHandler={props.breadcrumbsHandler}
                  addToTable={props.addToOperationsTable}
                  removeFromTable={props.removeFromOperationsTable}
                  updateInTable={props.updateInOperationsTable}
                  reset={props.resetOperations}
                />
              </Tab>
            </Tabs>
          </div>
          <ButtonBar
            onSave={props.onSave}
            disabled={props.disabled}
            partyId={props.partyId}
          />
        </div>
      </div>
    </ProcessComponent>
  );
};

export default InvolvementRoleType;
